import '../app/rxjs-operators';
import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TrackingModule, CustomErrorHandler } from '@shared/tracking';
import { CookieModule } from '@shared/cookie';
import { CompatTrackingComponent } from './compat-tracking.component';
import { CompatNavigationComponent } from './compat-navigation.component';
import { CompatContactListComponent } from './compat-contact-list.component';
import { CompatChatComponent } from './compat-chat.component';

import { environment } from '../environments/environment';

// This allows us to load Angular components on legacy server-side pages.
@NgModule({
  imports: [
    BrowserModule,
    CookieModule.forRoot(),
    TrackingModule.initialize(
      environment.trackingConfig,
      environment.authConfig
    )
  ],
  declarations: [
    CompatTrackingComponent,
    CompatNavigationComponent,
    CompatContactListComponent,
    CompatChatComponent,
    // DO NOT ADD ANYTHING TO THAT LIST WITHOUT TALKING TO @frontend-infra
    // FIRST.
  ],
  providers: [
    { provide: ErrorHandler, useClass: CustomErrorHandler }
  ],
  bootstrap: [
    CompatTrackingComponent,
    CompatNavigationComponent,
    CompatContactListComponent,
    CompatChatComponent,
  ]
})
export class CompatModule { }



// WEBPACK FOOTER //
// ./src/compat/compat.module.ts